import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/store/AppContext";
import { Layout } from "@/components/Layout";
import Onboarding from "@/screens/Onboarding";
import Today from "@/screens/Today";
import Projects from "@/screens/Projects";
import Roles from "@/screens/Roles";
import Focus from "@/screens/Focus";
import FridayReset from "@/screens/FridayReset";

const Gate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data } = useApp();
  if (!data.onboarded) return <Navigate to="/onboarding" replace />;
  return <>{children}</>;
};

const OnboardingRoute: React.FC = () => {
  const { data } = useApp();
  if (data.onboarded) return <Navigate to="/today" replace />;
  return <Onboarding />;
};

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/onboarding" element={<OnboardingRoute />} />
    <Route
      element={
        <Gate>
          <Layout />
        </Gate>
      }
    >
      <Route path="/today" element={<Today />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/roles" element={<Roles />} />
      <Route path="/focus" element={<Focus />} />
      <Route path="/reset" element={<FridayReset />} />
    </Route>
    <Route path="*" element={<Navigate to="/today" replace />} />
  </Routes>
);

const App: React.FC = () => (
  <AppProvider>
    <BrowserRouter>
      <AppRoutes />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#212621",
            border: "1px solid rgba(33,38,33,0.06)",
            borderRadius: "16px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  </AppProvider>
);

export default App;
